export default {
  computed: {
    shippingTaskHooksFilters() {
      return {
        title: 'Shippings Tasks Hooks',
        filters: {
          columns: [
            {
              class: 'col-4',
              filters: [
                {
                  name: 'shippingId',
                  label: this.$gettext('Shipping ID'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [true]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'storeId',
                  label: this.$gettext('Store ID'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [true]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-4',
              filters: [
                {
                  name: 'status',
                  label: this.$gettext('Status'),
                  type: 'checkbox-group',
                  value: [],
                  options: [
                    'givenUp',
                    'processed'
                  ],
                  stacked: true,
                  callback: (val) => {
                    if (val?.length > 0) {
                      return [true]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
